<div class="maps-container">
  <google-map 
    [height]="height" 
    width="100%" 
    [options]="mapOptions"
    (mapClick)="closeSheet()"> <map-marker
      *ngFor="let marker of markers; let i = index"
      [position]="{ lat: marker.lat, lng: marker.lng }"
      [title]="marker.name || ''"
      (mapClick)="onMarkerClick(marker)" 
      [options]="getMarkerOptions(i)">
    </map-marker>

  </google-map>
</div>